import openLoader from './open-loader.action';

export default openLoader;
